import share from '@/api/share';
import { SHARE_TRAINER, SHARE_COURSE, SHARE_INVITE, SHARE_SUCCESS } from './types';

export default {
    [SHARE_TRAINER]({ commit }, payload) {
        return share
            .trainer(payload.id)
            .then(resp => commit(SHARE_SUCCESS, resp));
    },
    [SHARE_COURSE]({ commit }, payload) {
        return share
            .course(payload.id)
            .then(resp => commit(SHARE_SUCCESS, resp));
    },
    [SHARE_INVITE]({ commit }, payload) {
        return share
            .invite(payload.date)
            .then(resp => commit(SHARE_SUCCESS, resp));
    },
};



// WEBPACK FOOTER //
// ./src/store/share/actions.js